import { isNumberHaveValue, toInt } from 'aa_common/front-end/helpers'
import { useFormikContext } from 'formik'
import get from 'lodash/get'
import moment from 'moment/moment'
import { useEffect, useRef } from 'react'

export const useSubsidyAmount = (acquisitionCostReference: number | undefined) => {
  const { values, setFieldValue } = useFormikContext()
  const acquiredAt = get(values, 'acquired_at')
  const usageStartedAt = get(values, 'usage_started_at')
  const subsidyAmount = get(values, 'subsidy_amount')
  const reductionAmount = get(values, 'reduction_amount')
  const netAcquisitionCost = get(values, 'net_acquisition_cost')
  const hasTransition = !!get(values, 'transition_at')
  const isAcquiredAtSameAsUsageStartedAt = moment(acquiredAt).isSame(moment(usageStartedAt))
  const changeSubsidyAmountManually = useRef(false)

  useEffect(() => {
    if (isNumberHaveValue(subsidyAmount)) {
      changeSubsidyAmountManually.current = true
    }
  }, [subsidyAmount])

  useEffect(() => {
    if (
      !Number.isNaN(toInt(String(subsidyAmount))) &&
      !Number.isNaN(toInt(String(acquisitionCostReference))) &&
      subsidyAmount <= acquisitionCostReference!
    ) {
      setFieldValue('net_acquisition_cost', acquisitionCostReference! - subsidyAmount)
    }
  }, [acquisitionCostReference, subsidyAmount])

  useEffect(() => {
    if (!hasTransition || !isNumberHaveValue(reductionAmount) || reductionAmount !== subsidyAmount) {
      setFieldValue('reduction_amount', subsidyAmount)
    }
  }, [subsidyAmount, reductionAmount, hasTransition])

  useEffect(() => {
    if (!usageStartedAt || (!isAcquiredAtSameAsUsageStartedAt && !hasTransition)) {
      setFieldValue('subsidy_amount', undefined)
      isNumberHaveValue(reductionAmount) && setFieldValue('reduction_amount', 0)
      isNumberHaveValue(netAcquisitionCost) && setFieldValue('net_acquisition_cost', acquisitionCostReference)
    } else if (!isNumberHaveValue(subsidyAmount)) {
      // Only set subsidy_amount to 0 when it has been changed manually
      changeSubsidyAmountManually.current && setFieldValue('subsidy_amount', 0)
    }
  }, [
    usageStartedAt,
    isAcquiredAtSameAsUsageStartedAt,
    hasTransition,
    subsidyAmount,
    reductionAmount,
    netAcquisitionCost,
    acquisitionCostReference,
  ])
}
